import React from 'react';
import CreateCustomer from '../components/CreateCustomer';
import PageLayout from '../components/layout/PageLayout';

const CustomerCreatePage = () => (
  <PageLayout>
    <CreateCustomer />
  </PageLayout>
);

export default CustomerCreatePage;
